import React from 'react';
import { connect } from 'react-redux'
import ReactHtmlParser from 'react-html-parser';

export  class loader extends React.PureComponent {  
  render() {
      let loderText =""
      if(this.props.appState!==undefined && this.props.appState.isLoaderText !==undefined && this.props.appState.isLoaderText !==null){
        loderText = ReactHtmlParser(this.props.appState.isLoaderText);
     }
    return (   
        <div className={this.props.appState!==undefined && this.props.appState.isLoaderActive ? "page-overlay active" : "page-overlay hide"}>
          <div className={this.props.appState!==undefined && this.props.appState.isLoaderActive ? "section-overlay" : "section-overlay"}>
                <div className="row section-loader vert-middle margin-vert-zero fluid-grid hide">
                    <div className="column padding-vert-zero section-overlay-column">
                        <div className="margin-top-small text-medium bold" id="loader-alert" role="alert" aria-live="assertive">
                            <div className= "spin-loader">
                            </div>
                            <div className="loader-messgae">
                              {loderText}
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
            </div>         
      
    );
  }
}
const mapStateToProps = (state) => {     
    return {
        appState: state.appVTP.isLoader
        }
    }
export default connect(
    mapStateToProps,    
)(loader);